import ReceptionsPage from "@/views/loggedPages/ReceptionsPage.vue";
import ReceptionDetailPage from "@/views/loggedPages/ReceptionDetailPage.vue";
import DeliveryTripsPage from "@/views/loggedPages/DeliveryTripsPage.vue";
import DeliveryTripDetailPage from "@/views/loggedPages/DeliveryTripDetailPage.vue";
import dashboardPage from "@/views/loggedPages/DashboardPage.vue";
import OrdersPage from "@/views/loggedPages/OrdersPage.vue";
import OrdersPageInfoauto from "@/views/loggedPages/OrdersPageInfoauto.vue";
import OrdersPageFlagged from "@/views/loggedPages/OrdersPageFlagged.vue";
import ProductsPage from "@/views/loggedPages/ProductsPage.vue";
import ShipmentsPage from "@/views/loggedPages/ShipmentsPage.vue";
import StoresPage from "@/views/loggedPages/StoresPage.vue";
import DepartmentsPage from "@/views/loggedPages/DepartmentsPage.vue";
import WarehousesPage from "@/views/loggedPages/WarehousesPage.vue";
import WarehouseLocationsPage from "@/views/loggedPages/WarehouseLocationsPage.vue";
import CarriersPage from "@/views/loggedPages/CarriersPage.vue";
import UsersPage from "@/views/loggedPages/UsersPage.vue";
import StockComparePage from "@/views/loggedPages/StockComparePage.vue";
import MovementHistoryPage from "@/views/loggedPages/MovementHistoryPage.vue";
import InfoautoPage from "@/views/loggedPages/InfoautoPage.vue";
import OrdersPageWarehouse from "@/views/loggedPages/OrdersPageWarehouse.vue";
import InfoPage from "@/views/loggedPages/InfoPage.vue";
import PrintNodePage from "@/views/loggedPages/PrintNodePage.vue";
import auth from "@/middleware/Auth";

export default [
  {
    path: "/dashboard",
    name: "DashboardPage",
    component: dashboardPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/orders",
    name: "OrdersPage",
    component: OrdersPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/orders-warehouse/:departmentCode?",
    name: "OrdersPageWarehouse",
    component: OrdersPageWarehouse,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/orders-infoauto",
    name: "OrdersPageInfoauto",
    component: OrdersPageInfoauto,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/orders-flagged",
    name: "OrdersPageFlagged",
    component: OrdersPageFlagged,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/products",
    name: "ProductsPage",
    component: ProductsPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/products/movements",
    name: "MovementHistoryPage",
    component: MovementHistoryPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/stores",
    name: "StoresPage",
    component: StoresPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/shipments",
    name: "ShipmentsPage",
    component: ShipmentsPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/departments",
    name: "DepartmentsPage",
    component: DepartmentsPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/warehouses",
    name: "WarehousesPage",
    component: WarehousesPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/warehouse-locations",
    name: "WarehouseLocationsPage",
    component: WarehouseLocationsPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/carriers",
    name: "CarriersPage",
    component: CarriersPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/users",
    name: "UsersPage",
    component: UsersPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/stock-compare",
    name: "StockComparePage",
    component: StockComparePage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/infoauto",
    name: "InfoautoPage",
    component: InfoautoPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/info",
    name: "InfoPage",
    component: InfoPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/printnode",
    name: "PrintNodePage",
    component: PrintNodePage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/receptions",
    name: "ReceptionsPage",
    component: ReceptionsPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/receptions/:id",
    name: "ReceptionDetailPage",
    component: ReceptionDetailPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/delivery/trips/:departmentCode?",
    name: "DeliveryTripsPage",
    component: DeliveryTripsPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  },
  {
    path: "/delivery/trips/:uuid",
    name: "DeliveryTripDetailPage",
    component: DeliveryTripDetailPage,
    meta: {
      middleware: [auth],
      layout: "LayoutLogged"
    }
  }
];
